// extracted by mini-css-extract-plugin
export default {"dropMenu":"dropMenu--MNYpj","border":"border--kGREJ","inactive":"inactive--nHvc2","userMenu":"userMenu--BVE2k","active":"active--WpKIh","tip":"tip--sIMzx"};